const params = new window.URLSearchParams(location.search);

export const redirect = params.get('redirect');

export const isChangeAccount = params.get('change') !== null;

export const tempToken = params.get('token');

export const isInvite = params.get('invite') !== null;
